export default __webpack_public_path__ + "static/media/B-1.97b00c94.mp3";